import { render } from "./HeroiconsSolidVideoCamera.vue?vue&type=template&id=a938e6b2"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidVideoCamera.vue"]])

export default __exports__